import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Note } from 'types/note';
import { alertService } from 'domain/alert/api/alertService';

export const noteQueryKey = 'note';

function useGetNotes(): UseQueryResult<Note[]> {
  return useQuery({
    queryKey: [noteQueryKey],
    queryFn: () => alertService.getNotes(),
  });
}

export default useGetNotes;
